<template>
  <a-col v-bind="$attrs" class="item">
    <a-row type="flex" align="middle">
      <a-col :span="labelCol">{{ label }}</a-col>
      <a-col :span="slotCol">
        <slot></slot>
      </a-col>
    </a-row>
  </a-col>
</template>

<script>
export default {
  name: 'SearchBarItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelCol: {
      type: [String, Number],
      default: 6,
    },
    slotCol: {
      type: [String, Number],
      default: 18,
    },
  },
}
</script>

<style lang="less" scoped>
.item {
  margin-bottom: 20px;
  padding-left: 12px;
}
</style>